export const defaultStyles = {
  calendarContainer: 'calendarContainer',
  heading: 'heading',
  prev: 'prev',
  next: 'next',
  title: 'title',
  dayWrapper: 'dayWrapper',
  currentMonth: 'currentMonth',
  daysOfWeek: 'daysOfWeek',
  yearsList: 'yearsList',
  monthsList: 'monthsList',
  selected: 'selected',
  today: 'today',
  dayPickerContainer: 'dayPickerContainer',
  disabled: 'disabled'
};
